import script from "./CheckboxgroupElement_tabs.vue?vue&type=script&lang=js"
export * from "./CheckboxgroupElement_tabs.vue?vue&type=script&lang=js"

import "./CheckboxgroupElement_tabs.vue?vue&type=style&index=0&id=6e99757b&lang=scss"

const __exports__ = script;

export default __exports__